// Módulos
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-prime-loader',
    templateUrl: './prime-loader.component.html',
    styleUrls: ['./prime-loader.component.scss'],
    standalone: false
})
export class PrimeLoaderComponent implements OnInit {
  @Input('fullScreen') isFullScreen = false;
  @Input() hideSpinner = false;
  @Input() text = 'Cargando...';

  ngOnInit() {
    // Remove focus from the currently active element
    (document.activeElement as HTMLElement).blur();
  }
}
